import { useState } from "react";

import "./Affilate.css";
import AffiliateFooter from "./AffiliateFooter";
import AffiliateHeader from "./AffiliateHeader";
import ShareAffiliateModal from "./ShareAffiliateModal";
import { Outlet } from "react-router-dom";

const AffiliateLayout = () => {
  const [open, setOpen] = useState(false);

  // const scrollRef = useRef(null);

  // useEffect(() => {
  //   if (scrollRef?.current) {
  //     setTimeout(() => {
  //       scrollRef.current.scrollIntoView({
  //         behavior: "smooth",
  //         block: "start",
  //       });
  //       window.scrollTo({ top: 0, behavior: "smooth" });
  //     }, 50);
  //   }
  // }, []);

  return (
    <>
      <div
        // ref={scrollRef}
        className="w-full md:mt-[0px] lg:overflow-auto lg:w-[85%] mb-[105px] lg:mb-[10px]"
        style={{ minHeight: "calc(-110px + 100dvh)" }}
      >
        <AffiliateHeader />
        <Outlet />
      </div>
      <AffiliateFooter setOpen={setOpen} open={open} />
      <ShareAffiliateModal setOpen={setOpen} open={open} />
    </>
  );
};

export default AffiliateLayout;
